import { render, staticRenderFns } from "./ChatroomFooter.vue?vue&type=template&id=00f55b7c&scoped=true&lang=pug&"
import script from "./ChatroomFooter.vue?vue&type=script&lang=js&"
export * from "./ChatroomFooter.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomFooter.vue?vue&type=style&index=0&id=00f55b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f55b7c",
  null
  
)

export default component.exports